import { z } from 'zod';
/**
 * Reunião de especialistas: o Secretário conduz, chama quem tem algo a dizer
 * sobre o assunto, cada um fala a partir dos dados do próprio dono e, no
 * fim, o Secretário fecha com a decisão sugerida e os próximos passos.
 */
export const MEETING_SPECIALISTS = [
    'contas',
    'lista_compras',
    'datas_importantes',
    'radar_precos',
    'noticias',
    'clima',
    'horoscopo',
];
export const meetingTurnSchema = z.object({
    id: z.uuid(),
    /** Quem fala: o dono, o Secretário (que conduz) ou um especialista. */
    role: z.enum(['owner', 'moderator', 'specialist']),
    /** Chave do especialista; null para o dono e o Secretário. */
    speaker: z.string().nullable(),
    text: z.string(),
    createdAt: z.iso.datetime(),
});
/** A ata: o que ficou decidido, por quê e o que fazer em seguida. */
export const meetingDecisionSchema = z.object({
    decision: z.string(),
    reasons: z.array(z.string()).max(4),
    steps: z.array(z.string()).max(5),
});
export const meetingSchema = z.object({
    id: z.uuid(),
    topic: z.string(),
    turns: z.array(meetingTurnSchema),
    decision: meetingDecisionSchema.nullable(),
    /** Perguntas que o dono ainda pode fazer nesta reunião. */
    followUpsLeft: z.number().int().nonnegative(),
    createdAt: z.iso.datetime(),
});
export const meetingSummarySchema = z.object({
    id: z.uuid(),
    topic: z.string(),
    decision: z.string().nullable(),
    createdAt: z.iso.datetime(),
});
export const meetingQuotaSchema = z.object({
    /** Reuniões por mês neste plano; 0 = o plano não inclui. */
    limit: z.number().int().nonnegative(),
    used: z.number().int().nonnegative(),
    remaining: z.number().int().nonnegative(),
});
export const meetingListSchema = z.object({
    meetings: z.array(meetingSummarySchema),
    quota: meetingQuotaSchema,
});
export const startMeetingSchema = z.object({ topic: z.string().trim().min(4).max(400) });
export const meetingMessageSchema = z.object({ text: z.string().trim().min(1).max(600) });
/** Eventos do fluxo de uma reunião, na ordem em que acontecem. */
export const meetingStreamEventSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('meeting'), id: z.uuid(), topic: z.string() }),
    /** Alguém pegou a palavra e está preparando a fala. */
    z.object({
        type: z.literal('speaking'),
        role: z.enum(['moderator', 'specialist']),
        speaker: z.string().nullable(),
    }),
    z.object({ type: z.literal('turn'), turn: meetingTurnSchema }),
    z.object({ type: z.literal('decision'), decision: meetingDecisionSchema }),
    z.object({ type: z.literal('done'), followUpsLeft: z.number().int().nonnegative() }),
    z.object({ type: z.literal('error'), code: z.string(), message: z.string() }),
]);
